<!--HEADER-->
<div class="additional-booking__header row" id="additionalBookingHeader">
  <div class="additional-booking__header-col col-12">
    <h3 class="additional-booking__intro"
        *appApplyIfNotEmpty="translationService.getTranslation('additionalBooking_intro')"
        [innerHTML]="translationService.getTranslation('additionalBooking_intro')"></h3>
  </div>
  <div class="additional-booking__header-col col-12">
    <p class="additional-booking__description"
       *appApplyIfNotEmpty="translationService.getTranslation('additionalBooking_description')"
       [innerHTML]="translationService.getTranslation('additionalBooking_description')"></p>
  </div>
</div>

<div class="additional-booking__content row">
  <div class="additional-booking__content-col col-12">

    <div class="additional-booking__spinner" style="text-align: center;" *ngIf="isStateUnknown">
      <app-loading-spinner></app-loading-spinner>
    </div>

    <ng-container *ngIf="isGuest">
      <div class="additional-booking__registered-hint" *ngIf="justRegistered"
           [innerHTML]="translationService.getTranslation('additionalBooking_registered_hint')"></div>
      <p class="additional-booking__guest-description"
         [innerHTML]="translationService.getTranslation('additionalBooking_guest_description')"></p>
      <div class="additional-booking__guest-actions">
        <button mat-raised-button color="primary"
                class="additional-booking__login-btn"
                (click)="goToLogin()"
                [innerHTML]="translationService.getTranslation('additionalBooking_button_login')"></button>
        <button mat-flat-button
                class="additional-booking__identification-btn btn btn-secondary"
                (click)="goToIdentification()"
                [innerHTML]="translationService.getTranslation('additionalBooking_button_identification')"></button>
      </div>
    </ng-container>

    <div class="additional-booking__checking" *ngIf="isAuthenticated && isLoading">
      <div class="additional-booking__spinner" style="text-align: center;">
        <app-loading-spinner></app-loading-spinner>
      </div>
      <p class="additional-booking__checking-text"
         [innerHTML]="translationService.getTranslation('additionalBooking_checking_eligibility')"></p>
    </div>

    <div class="additional-booking__checking" *ngIf="isAuthenticated && !isLoading">
      <div class="additional-booking__errors" style="text-align: center;">
        <app-general-errors [errors]="errors"></app-general-errors>
      </div>

      <!-- Alle Abonnements anzeigen -->
      <div *ngIf="subscriptions.length > 0">
        <div *ngFor="let subscription of subscriptions">
          <app-subscription-card [subscription]="subscription"
                                 [actionLabel]="translationService.getTranslation('additionalBooking_button_book')"
                                 (action)="bookAdditionalProduct($event)"></app-subscription-card>
        </div>
      </div>

      <!-- Nichts zuzubuchen: Der Hinweis nennt den Grund, der Button führt dorthin, wo der Kunde
           weiterkommt - in seine Abos bzw. auf das Abo, in dem das Produkt schon läuft. -->
      <div class="additional-booking__no-booking" *ngIf="hasNoEligibleSubscription || hasProductAlready">
        <p class="additional-booking__no-booking-text" *ngIf="hasNoEligibleSubscription"
           [innerHTML]="translationService.getTranslation('additionalBooking_noEligibleSubscriptions')"></p>
        <p class="additional-booking__no-booking-text" *ngIf="hasProductAlready"
           [innerHTML]="translationService.getTranslation('additionalBooking_alreadyBooked')"></p>
        <div class="additional-booking__no-booking-actions">
          <button mat-raised-button color="primary" *ngIf="hasNoEligibleSubscription"
                  class="additional-booking__subscriptions-btn" (click)="goToSubscriptions()"
                  [innerHTML]="translationService.getTranslation('additionalBooking_button_toSubscriptions')"></button>
          <button mat-raised-button color="primary" *ngIf="hasProductAlready"
                  class="additional-booking__booked-subscription-btn" (click)="goToBookedSubscription()"
                  [innerHTML]="translationService.getTranslation('additionalBooking_button_toSubscription')"></button>
        </div>
      </div>
    </div>
  </div>
</div>
